// extracted by mini-css-extract-plugin
export default {"textContainer":"styles_textContainer__UTG32","cameraIcon":"styles_cameraIcon__ButUI"};